import {Action, createAction} from '@ngrx/store';

export const LOGOUT = '[App] Logout';
export const logoutAction = createAction('[App] Logout');

